import classNames from 'classnames';
import AppContext from 'context/Context';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Collapse, Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
import { useSelector } from 'react-redux';

const CollapseItems = ({ route }) => {
  const { pathname } = useLocation();

  const openCollapse = childrens => {
    const checkLink = children => {
      if (children.to === pathname) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, 'children') &&
        children.children.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames('dropdown-indicator cursor-pointer', {
          'text-500': !route.active
        })}
        aria-expanded={open}
        // {...route}
      >
        <NavbarVerticalMenuItem route={route} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.array.isRequired,
    active: PropTypes.bool
  }).isRequired
};

const matchesAny = (patterns, pathname) =>
  (patterns || []).some(pattern => new RegExp(pattern).test(pathname));

const isRouteActive = (isActive, route, pathname) => {
  if (matchesAny(route.activeExclude, pathname)) {
    return false;
  }
  return isActive || matchesAny(route.activeMatch, pathname);
};

const NavbarVerticalMenu = ({ routes }) => {
  const {
    config: { showBurgerMenu },
    setConfig
  } = useContext(AppContext);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isPractice = params.get('isPractice');

  const features = useSelector(state => state.authentication.features || []);

  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  // Filter routes based on enabled features
  const filteredRoutes = routes
    .map(route => {
      if (route.name === 'Master Client' || route.name === 'Practice Module') {
        if (
          features &&
          features.some(f => f.Key === 'mastersigning' && f.Value === true)
        ) {
          return route;
        }
        return null;
      }
      return route;
    })
    .filter(Boolean);

  return filteredRoutes.map(route => {
    if (!route.children) {
      return (
        <Nav.Item as="li" key={route.name} onClick={handleNavItemClick}>
          <NavLink
            target={route.target ? route.target : '_self'}
            end={route.exact}
            to={route.to}
            state={{ open: route.to === '/authentication-modal' }}
            className={({ isActive }) =>
              isRouteActive(isActive, route, location.pathname) &&
              route.to !== '#!'
                ? `${isPractice !== '1' ? `active` : ''} nav-link`
                : `${
                    isPractice == '1' &&
                    route.to == '/notary/signing/practice-module'
                      ? `active`
                      : ''
                  } nav-link`
            }
          >
            <NavbarVerticalMenuItem route={route} />
          </NavLink>
        </Nav.Item>
      );
    }
    return <CollapseItems route={route} key={route.name} />;
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape(NavbarVerticalMenuItem.propTypes))
    .isRequired
};

export default NavbarVerticalMenu;
